import "./column-components.b2a20dc1.js";
import $kduwi$macrostrathyper from "@macrostrat/hyper";
import {useContext as $kduwi$useContext} from "react";
import $kduwi$classnames from "classnames";
import $kduwi$uibox from "ui-box";
import {path as $kduwi$path} from "d3-path";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea149"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea149"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
var $4a0ea9dcf1a07b76$exports = {};

$parcel$export($4a0ea9dcf1a07b76$exports, "ColumnBox", () => $4a0ea9dcf1a07b76$export$32a0ad71237b9760);
$parcel$export($4a0ea9dcf1a07b76$exports, "zigZagBoxPath", () => $4a0ea9dcf1a07b76$export$3043bd3cc20d22a5);
$parcel$export($4a0ea9dcf1a07b76$exports, "drawZigZagAtConstantHeight", () => $4a0ea9dcf1a07b76$export$2cf300d53db8f1c);



var $aVUB5 = parcelRequire("aVUB5");



function $4a0ea9dcf1a07b76$export$32a0ad71237b9760(props) {
    const { offsetTop: offsetTop, absolutePosition: absolutePosition, className: className, ...rest } = props;
    const { pixelsPerMeter: pixelsPerMeter, zoom: zoom } = (0, $kduwi$useContext)((0, $aVUB5.ColumnContext));
    const marginTop = offsetTop * pixelsPerMeter * zoom;
    let pos = {
        marginTop: marginTop
    };
    if (absolutePosition) pos = {
        position: "absolute",
        top: marginTop
    };
    return (0, $kduwi$macrostrathyper)((0, $kduwi$uibox), {
        className: (0, $kduwi$classnames)("column-box", className),
        ...pos,
        ...rest
    });
}
function $4a0ea9dcf1a07b76$export$3043bd3cc20d22a5(x, y, width, height, top, bottom) {
    const d = (0, $kduwi$path)();
    const x1 = x + width;
    // Start path at the top
    d.moveTo(x, y);
    if (top) $4a0ea9dcf1a07b76$export$2cf300d53db8f1c(d, x, x1, y);
    else d.lineTo(x1, y);
    const yBottom = y + height;
    d.lineTo(x1, yBottom);
    // Draw the bottom
    if (bottom) $4a0ea9dcf1a07b76$export$2cf300d53db8f1c(d, x1, x, yBottom);
    else d.lineTo(x, yBottom);
    // Draw the left edge
    d.closePath();
    // Now render the path;
    return d.toString();
}
function $4a0ea9dcf1a07b76$export$2cf300d53db8f1c(d, x0, x1, y) {
    const zigZagWidth = 10;
    const zigZagHeight = 4;
    const deltaX = x1 - x0;
    const width = Math.abs(deltaX);
    const nZigZags = Math.floor(width / zigZagWidth - 0.5);
    const _zigZagWidth = width / (nZigZags + 0.5);
    let dy = zigZagHeight / 2;
    // Each zig-zag consists of a short outward motion
    let dx = _zigZagWidth / 4;
    let cx = x0;
    let cy = y;
    if (deltaX < 0) {
        dx = -dx;
        dy = -dy;
    }
    const doZigZag = (last = false)=>{
        cx += dx;
        cy -= dy;
        d.lineTo(cx, cy);
        let scalar = last ? 1 : 2;
        cx += dx * scalar;
        cy += dy * scalar;
        d.lineTo(cx, cy);
        cx += dx;
        cy -= dy;
    };
    d.lineTo(x0, y);
    // Move to the offset
    //d.lineTo(cx, y);
    // Draw the zig-zags
    for(let i = 0; i < nZigZags; i++)doZigZag();
    // Draw the last half zig-zag
    doZigZag(true);
    // Draw to the edge
    d.lineTo(x1, y);
}


export {$4a0ea9dcf1a07b76$export$32a0ad71237b9760 as ColumnBox, $4a0ea9dcf1a07b76$export$3043bd3cc20d22a5 as zigZagBoxPath, $4a0ea9dcf1a07b76$export$2cf300d53db8f1c as drawZigZagAtConstantHeight};
//# sourceMappingURL=column-components.30bb6ff8.js.map
